import React from "react";
import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { Card, Button } from "../ui";
import BrandLogoMark from "../ui/BrandLogoMark";
import AuthDottedSurface from "./AuthDottedSurface";
import { acmeMarketingHeadlineSx } from "../../theme/acmeTheme";
import {
  authPageOuterSx,
  authHeroColumnSx,
  authHeroGradientSx,
  authHeroBrandSx,
  authHeroQuoteSx,
  authFormColumnSx,
  authFormRadialSx,
  authFormInnerSx,
  authCenterOuterSx,
  authCenterCardSx,
  authHomeButtonSx,
} from "./authSplitShellSx";

const DEFAULT_QUOTE =
  "I don't adapt to the market — I make the market adapt to me!";
const DEFAULT_QUOTE_AUTHOR = "Aleksandr Khrustalov";

/**
 * Auth layouts: split hero + form (login/register) or centered card (forgot/reset).
 */
export default function AuthSplitShell({
  variant = "split",
  quote = DEFAULT_QUOTE,
  quoteAuthor = DEFAULT_QUOTE_AUTHOR,
  children,
}) {
  if (variant === "center") {
    return (
      <Box sx={authCenterOuterSx}>
        <Card sx={authCenterCardSx} elevation={0}>
          <BrandLogoMark to="/" sx={{ mb: 3 }} />
          {children}
        </Card>
      </Box>
    );
  }

  return (
    <Box sx={authPageOuterSx}>
      <Box sx={authHeroColumnSx}>
        <Box sx={authHeroGradientSx} />
        <Box sx={authHeroBrandSx}>
          <BrandLogoMark to="/" variant="plain" size="lg" />
        </Box>
        <Box sx={authHeroQuoteSx} component="blockquote">
          <Typography
            sx={{
              ...acmeMarketingHeadlineSx,
              fontSize: '1.25rem',
              lineHeight: 1.55,
              color: 'rgba(255,255,255,0.92)',
            }}
          >
            &ldquo;{quote}&rdquo;
          </Typography>
          <Typography
            component="footer"
            sx={{
              mt: 1.5,
              fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
              fontSize: "0.8125rem",
              fontWeight: 600,
              color: "rgba(255,255,255,0.55)",
            }}
          >
            ~ {quoteAuthor}
          </Typography>
        </Box>
        <AuthDottedSurface />
      </Box>

      <Box sx={authFormColumnSx}>
        <Box sx={authFormRadialSx}>
          <Box
            sx={{
              position: "absolute",
              top: 0,
              right: 0,
              width: 560,
              height: 640,
              transform: "translateY(-35%)",
              borderRadius: "50%",
              background: `radial-gradient(68.54% 68.72% at 55.02% 31.46%, rgba(10,10,10,0.06) 0%, rgba(10,10,10,0.02) 50%, rgba(10,10,10,0.01) 80%)`,
            }}
          />
          <Box
            sx={{
              position: "absolute",
              top: 0,
              right: 0,
              width: 240,
              height: 640,
              transform: "translate(5%, -50%)",
              borderRadius: "50%",
              background: `radial-gradient(50% 50% at 50% 50%, rgba(10,10,10,0.04) 0%, rgba(10,10,10,0.01) 80%, transparent 100%)`,
            }}
          />
        </Box>

        <Button
          component={Link}
          to="/"
          variant="ghost"
          size="sm"
          startIcon={<ChevronLeftIcon sx={{ fontSize: 18 }} />}
          sx={authHomeButtonSx}
        >
          Home
        </Button>

        <Box
          sx={{
            display: { xs: "flex", lg: "none" },
            mb: 1,
            width: "100%",
            maxWidth: 384,
            mx: "auto",
          }}
        >
          <BrandLogoMark to="/" />
        </Box>

        <Box sx={authFormInnerSx}>{children}</Box>
      </Box>
    </Box>
  );
}
